// extracted by mini-css-extract-plugin
export default {"btn":"addmacro_btn__HSSjE","overflow-scroll":"addmacro_overflow-scroll__sgvdc"};